import React from 'react';
import { CircularProgress } from '@mui/material'

const Spinner = ({ size = 50, thickness = 3, color = 'var(--accent)' }) => {
  return (
    <div className='spinner-container'>
      <CircularProgress
        thickness={thickness}
        sx={{ color }}
        size={size} />
    </div>
  );
};

export default Spinner;